export default __webpack_public_path__ + "static/media/11.b998c7e2.png";